if (typeof ProductQuantity !== 'function') {

	class ProductQuantity extends HTMLElement {

			constructor() {

					super();
					if (this.querySelector('.qty-selector') != null) {
							const qty = this.querySelector('.qty-selector'),
									qtyMinus = this.querySelector('.qty-minus'),
									qtyPlus = this.querySelector('.qty-plus'),
									qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
							qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

						const getLocationLimit = () => {
							if (!this.hasAttribute('data-js-product-quantity')) return qtyMax;

							const addToCartForm = this.closest('form[action*="/cart/add"]')
								|| this.closest('product-form')?.querySelector('form[action*="/cart/add"]')
								|| document.querySelector('form[action*="/cart/add"]');
							const productForm = this.closest('product-form') || addToCartForm;
							const locationLimit = Number(
								addToCartForm?.getAttribute('data-limit-location')
								|| productForm?.getAttribute('data-limit-location')
							);

							return Number.isFinite(locationLimit) && locationLimit >= 0
								? Math.min(locationLimit, qtyMax)
								: qtyMax;
						};

						const notifyQuantityChange = () => {
							qty.dispatchEvent(new Event('input', { bubbles: true }));
						};

							if (parseInt(qty.value) - 1 < qtyMin) {
									qtyMinus.classList.add('disabled');
							}
							if (parseInt(qty.value) + 1 > qtyMax) {
									qtyPlus?.classList.add('disabled');
							}

							qtyMinus.addEventListener('click', (e) => {
									e.preventDefault();
									if (!qtyMinus.classList.contains('disabled')) {
											const currentQty = parseInt(qty.value);
											if (currentQty - 1 >= qtyMin) {
											qty.value = currentQty - 1;
											qtyPlus?.classList.remove('disabled');
											notifyQuantityChange();
											}
											if (currentQty - 1 <= qtyMin) {
													qtyMinus.classList.add('disabled');
											}
									}
							});

							qtyPlus?.addEventListener('click', (e) => {
									e.preventDefault();
									const checkQtyMax = getLocationLimit();

									if (!qtyPlus?.classList.contains('disabled')) {
											const currentQty = parseInt(qty.value);
											if (currentQty + 1 <= checkQtyMax) {
											qty.value = currentQty + 1;
											qtyMinus.classList.remove('disabled');
											notifyQuantityChange();
											}
											if (currentQty + 1 >= checkQtyMax) {
													qtyPlus?.classList.add('disabled');
											}
									}
							});

							qty.addEventListener('change', (e) => {
								e.preventDefault();
								const checkQtyMax = getLocationLimit();
								const currentQty = Number.isFinite(parseInt(qty.value)) ? parseInt(qty.value) : qtyMin;
								if (checkQtyMax <= 0) {
									qty.value = qtyMin;
									qtyMinus.classList.add('disabled');
									qtyPlus?.classList.add('disabled');
									return;
								}
								if (currentQty >= checkQtyMax) {
									qty.value = checkQtyMax;
									qtyMinus.classList.remove('disabled');
									qtyPlus?.classList.add('disabled');
								}

								if (currentQty < qtyMin + 1) {
									qtyMinus.classList.add('disabled');
									qtyPlus?.classList.remove('disabled');
								}
						});
					}

			}

	}

	if (typeof customElements.get('product-quantity') == 'undefined') {
			customElements.define('product-quantity', ProductQuantity);
	}

}
